import driverPerformance from '@/api/report/driver-performance'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
    ...baseState,
    dateRange: [
        moment().format('DD-MM-YYYY'),
        moment().format('DD-MM-YYYY')
    ],
    driverIds: [],
    summary: {
        total: 0,
        success: 0,
        pending: 0,
        on_delivery: 0,
        cancelled: 0,
        return: 0
    }
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_DATE_RANGE(state, dateRange) {
        state.dateRange = dateRange
    },
    SET_DRIVER_IDS(state, driverIds) {
        state.driverIds = driverIds
    },
    SET_SUMMARY(state, summary = {}) {
        state.summary = Object.assign(
            {
                total: 0,
                success: 0,
                pending: 0,
                on_delivery: 0,
                cancelled: 0,
                return: 0
            },
            summary || {}
        )
    }
}

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.currentPage,
                perPage: context.state.pagination.perPage,
                date_range: context.state.dateRange,
                driver_ids: context.state.driverIds
            },
            attributes
        )

        return driverPerformance.viewData({ params }).then(response => {
            context.commit('SET_SUMMARY', response.summary)
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    }
}
